module.exports = __webpack_public_path__ + "img/spicy_level_two.f7b073ad.svg";